// THIS MODULE IS DEPRECATED.
// useApi.js should be used instead
import { useEffect, useState } from 'react';
var DebounceInterval = 250;
var useFetch = function (url) {
    var _a = useState(null), response = _a[0], setResponse = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    useEffect(function () {
        var abortController = new AbortController();
        var signal = abortController.signal;
        var fetchData = function () {
            if (!url) {
                return;
            }
            setIsLoading(true);
            fetch(url, { signal: signal })
                .then(function (resp) { return resp.json(); })
                .then(function (data) {
                setIsLoading(false);
                setResponse(data);
            })["catch"](function (reqError) {
                setIsLoading(false);
                if (!abortController.signal.aborted) {
                    setError(reqError);
                }
            });
        };
        var timer = setTimeout(fetchData, DebounceInterval);
        return function () {
            clearTimeout(timer);
            setIsLoading(false);
            abortController.abort();
        };
    }, [url]);
    return { response: response, error: error, isLoading: isLoading };
};
export default useFetch;
//# sourceMappingURL=useFetch.js.map